import React, { useEffect, useState } from "react";
import { getauditlogs, getauditstatistics, getuseractivity } from "../../../services/admin";
import { toast } from "react-toastify";
import moment from "moment";

export default function AuditTrail() {
    const [logs, setLogs] = useState([]);
    const [statistics, setStatistics] = useState(null);
    const [userActivity, setUserActivity] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('logs'); // logs, statistics, user-activity

    const [filters, setFilters] = useState({
        module: "",
        action: "",
        start_date: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        search: "",
        limit: 100
    });

    useEffect(() => {
        fetchLogs();
        fetchStatistics();
        fetchUserActivity();
    }, []);

    const fetchLogs = (filterParams = {}) => {
        setLoading(true);
        const params = { ...filters, ...filterParams };
        getauditlogs(params).then((res) => {
            if (res.status === true) {
                setLogs(res.data);
            }
            setLoading(false);
        });
    };

    const fetchStatistics = () => {
        getauditstatistics(filters).then((res) => {
            if (res.status === true) {
                setStatistics(res.data);
            }
        });
    };

    const fetchUserActivity = () => {
        getuseractivity(filters).then((res) => {
            if (res.status === true) {
                setUserActivity(res.data);
            }
        });
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleSearch = () => {
        fetchLogs();
        fetchStatistics();
        fetchUserActivity();
    };

    const getActionBadge = (action) => {
        const badges = {
            'Created': 'bg-success',
            'Updated': 'bg-primary',
            'Deleted': 'bg-danger',
            'Posted': 'bg-info',
            'Approved': 'bg-success',
            'Cancelled': 'bg-warning',
            'Closed': 'bg-secondary'
        };
        return <span className={`badge ${badges[action] || 'bg-secondary'}`}>{action}</span>;
    };

    const getModuleBadge = (module) => {
        const badges = {
            'Accounts': 'bg-primary',
            'Budget': 'bg-warning',
            'Fixed Assets': 'bg-info',
            'Loans': 'bg-success'
        };
        return <span className={`badge ${badges[module] || 'bg-secondary'}`}>{module}</span>;
    };

    const formatValue = (value) => {
        if (value === null || value === undefined) return '-';
        if (typeof value === 'object') return JSON.stringify(value);
        return value.toString();
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Audit Trail</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Audit Trail
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Audit Trail</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                    <button
                                        className={`btn btn-sm ${activeTab === 'logs' ? 'btn-primary' : 'btn-outline-primary'} me-1`}
                                        onClick={() => setActiveTab('logs')}
                                    >
                                        <i className="fa fa-list"></i> Audit Logs
                                    </button>
                                    <button
                                        className={`btn btn-sm ${activeTab === 'statistics' ? 'btn-primary' : 'btn-outline-primary'} me-1`}
                                        onClick={() => setActiveTab('statistics')}
                                    >
                                        <i className="fa fa-bar-chart"></i> Statistics
                                    </button>
                                    <button
                                        className={`btn btn-sm ${activeTab === 'user-activity' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setActiveTab('user-activity')}
                                    >
                                        <i className="fa fa-users"></i> User Activity
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            {/* Filters */}
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label className="form-label">Module</label>
                                            <select
                                                className="default-select  form-control wide"
                                                name="module"
                                                value={filters.module}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">All Modules</option>
                                                <option value="Accounts">Accounts</option>
                                                <option value="Budget">Budget</option>
                                                <option value="Fixed Assets">Fixed Assets</option>
                                                <option value="Loans">Loans</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Action</label>
                                            <select
                                                className="default-select  form-control wide"
                                                name="action"
                                                value={filters.action}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">All Actions</option>
                                                <option value="Created">Created</option>
                                                <option value="Updated">Updated</option>
                                                <option value="Deleted">Deleted</option>
                                                <option value="Posted">Posted</option>
                                                <option value="Approved">Approved</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="start_date"
                                                value={filters.start_date}
                                                onChange={handleFilterChange}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="end_date"
                                                value={filters.end_date}
                                                onChange={handleFilterChange}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Search</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="search"
                                                value={filters.search}
                                                onChange={handleFilterChange}
                                                placeholder="Search record..."
                                            />
                                        </div>
                                        <div className="col-md-1">
                                            <label className="form-label">&nbsp;</label>
                                            <button
                                                className="btn btn-primary w-100"
                                                onClick={handleSearch}
                                            >
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Audit Logs Tab */}
                            {activeTab === 'logs' && (
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th width="12%">Date/Time</th>
                                                <th width="10%">User</th>
                                                <th width="8%">Action</th>
                                                <th width="10%">Module</th>
                                                <th width="10%">Record Type</th>
                                                <th width="15%">Record</th>
                                                <th>Description</th>
                                                <th width="10%">IP Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {logs.length > 0 ? (
                                                logs.map((log) => (
                                                    <tr key={log.id}>
                                                        <td>
                                                            <small>{moment(log.created_at).format('DD-MM-YYYY HH:mm:ss')}</small>
                                                        </td>
                                                        <td>{log.user?.name || 'Unknown'}</td>
                                                        <td>{getActionBadge(log.action)}</td>
                                                        <td>{getModuleBadge(log.module)}</td>
                                                        <td><small>{log.record_type}</small></td>
                                                        <td><strong>{log.record_identifier}</strong></td>
                                                        <td>
                                                            <small>{log.description}</small>
                                                            {(log.old_values || log.new_values) && (
                                                                <button
                                                                    className="btn btn-sm btn-link p-0 ms-2"
                                                                    onClick={() => {
                                                                        const changes = [];
                                                                        if (log.old_values && log.new_values) {
                                                                            Object.keys(log.new_values).forEach(key => {
                                                                                if (log.old_values[key] !== log.new_values[key]) {
                                                                                    changes.push(`${key}: ${formatValue(log.old_values[key])} → ${formatValue(log.new_values[key])}`);
                                                                                }
                                                                            });
                                                                        } else if (log.new_values) {
                                                                            Object.keys(log.new_values).forEach(key => {
                                                                                changes.push(`${key}: ${formatValue(log.new_values[key])}`);
                                                                            });
                                                                        }
                                                                        toast.info(changes.join('\n'), { autoClose: 8000 });
                                                                    }}
                                                                    title="View Changes"
                                                                >
                                                                    <i className="fa fa-eye"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td><small>{log.ip_address}</small></td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-muted">
                                                        {loading ? 'Loading...' : 'No audit logs found for the selected criteria.'}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {logs.length > 0 && (
                                        <div className="alert alert-info">
                                            <small>Showing {logs.length} most recent audit logs. Use filters to narrow down results.</small>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Statistics Tab */}
                            {activeTab === 'statistics' && statistics && (
                                <>
                                    {/* Summary Cards */}
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <div className="card bg-primary text-white">
                                                <div className="card-body">
                                                    <h6>Total Audit Logs</h6>
                                                    <h2>{statistics.total_logs.toLocaleString()}</h2>
                                                    <small>In selected date range</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card bg-info text-white">
                                                <div className="card-body">
                                                    <h6>Active Users</h6>
                                                    <h2>{statistics.total_users}</h2>
                                                    <small>Users who performed actions</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Actions Breakdown */}
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <h6>Actions Breakdown</h6>
                                                </div>
                                                <div className="card-body">
                                                    <table className="table table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Action</th>
                                                                <th className="text-end">Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(statistics.by_action).map(([action, count]) => (
                                                                <tr key={action}>
                                                                    <td>{getActionBadge(action)}</td>
                                                                    <td className="text-end"><strong>{count}</strong></td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card">
                                                <div className="card-header bg-light">
                                                    <h6>Modules Breakdown</h6>
                                                </div>
                                                <div className="card-body">
                                                    <table className="table table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Module</th>
                                                                <th className="text-end">Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {Object.entries(statistics.by_module).map(([module, count]) => (
                                                                <tr key={module}>
                                                                    <td>{getModuleBadge(module)}</td>
                                                                    <td className="text-end"><strong>{count}</strong></td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Recent Activity */}
                                    <div className="card">
                                        <div className="card-header bg-light">
                                            <h6>Recent Activity (Last 10)</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Date/Time</th>
                                                            <th>User</th>
                                                            <th>Action</th>
                                                            <th>Description</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {statistics.recent_activity.map((log) => (
                                                            <tr key={log.id}>
                                                                <td><small>{moment(log.created_at).format('DD-MM-YYYY HH:mm')}</small></td>
                                                                <td>{log.user?.name}</td>
                                                                <td>{getActionBadge(log.action)}</td>
                                                                <td><small>{log.description}</small></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* User Activity Tab */}
                            {activeTab === 'user-activity' && (
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="table-light">
                                            <tr>
                                                <th>User</th>
                                                <th className="text-center">Total Actions</th>
                                                <th>Action Breakdown</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userActivity.length > 0 ? (
                                                userActivity.map((activity) => (
                                                    <tr key={activity.user_id}>
                                                        <td>
                                                            <strong>{activity.user?.name}</strong>
                                                            <br />
                                                            <small className="text-muted">{activity.user?.email}</small>
                                                        </td>
                                                        <td className="text-center">
                                                            <h4>{activity.total_actions}</h4>
                                                        </td>
                                                        <td>
                                                            {Object.entries(activity.action_breakdown).map(([action, count]) => (
                                                                <span key={action} className="me-2">
                                                                    {getActionBadge(action)} <strong>{count}</strong>
                                                                </span>
                                                            ))}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center text-muted">
                                                        No user activity found for the selected date range.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
